import Request from "../config/Request";

const identify = async (data) => {
    return Request.post('https://apis.ffeleven.com/api/web_portal/identify', data)
}

const verify = async (data) => {
    return Request.post('https://apis.ffeleven.com/api/web_portal/verify', data)
}

const getCategories = async (operator) => {
    return Request.get('https://apis.wellbeprime.com/apis/category/'+operator)
}

const getVideos = async (category,operator) => {
    return Request.get('https://apis.wellbeprime.com/apis/videos/'+category+'/operator/'+operator)
}

const getVideo = async(code,video_public_id) =>{
    return Request.get('https://apis.wellbeprime.com/apis/videos/'+code+'/'+video_public_id)
}

const Unsub= async(data) =>{
    return Request.post('https://apis.wellbeprime.com/apis/client/unsub_user/',data)
}

const GETUSER = async(data) => {
    return Request.get('https://apis.wellbeprime.com/apis/client/get_user?user_public_id='+data)
}

const SetUserInfo  = async(data) => {
    return Request.post("https://apis.wellbeprime.com/apis/client/set_user_info",data)
}

const GetUserInfo = async(data) => {
    return Request.get(`https://apis.wellbeprime.com/apis/client/get_user_body_info?user_public_id=${data}`)
}

const GetDailyPlan = async(data) => {
    return Request.get(`https://apis.wellbeprime.com/apis/client/get_daily_plan?user_public_id=${data}`)
}

const SetUserAvatar = async(data)=>{
    return Request.post("https://apis.wellbeprime.com/apis/client/set_user_avatar",data)
}

const GetUserAvatar = async(data)=>{
    return Request.get(`https://apis.wellbeprime.com/apis/client/get_user_avatar?user_public_id=${data}`)
}

const PredictBmiWHR= async(data)=>{
     return Request.post("https://wellbe-api-298047552813.us-central1.run.app/bmi_whr_predict",data)
}

export {
    identify,
    verify,
    getCategories,
    getVideos,
    getVideo,
    Unsub,
    GETUSER,
    SetUserInfo,
    GetUserInfo,
    GetDailyPlan,
    SetUserAvatar,
    GetUserAvatar,
    PredictBmiWHR
}